<template>
  <div class="site-access">
    <el-form label-position="left" label-width="180px">
      <el-form-item label="机器人样式：">
        <upload-img :img.sync="siteForm.robot_style"
          >建议上传图片尺寸为86px*126px</upload-img
        >
      </el-form-item>
      <el-form-item label="显示机器人：">
        <el-checkbox-group v-model="siteForm.robot_show">
          <el-checkbox label="1">文字机器人</el-checkbox>
          <!-- <el-checkbox label="2">人工分答</el-checkbox> -->
          <el-checkbox label="3">电话机器人</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="文字机器人入口名称：">
        <el-input
          placeholder="输入文字机器人名称【示例：考生咨询】"
          v-model="siteForm.robot_text"
        ></el-input>
      </el-form-item>
      <el-form-item label="文字机器人样式：">
        <upload-img :img.sync="siteForm.robot_text_image"
          >建议上传图片尺寸为50px*50px</upload-img
        >
      </el-form-item>
      <el-form-item label="电话机器人入口名称：">
        <el-input
          placeholder="输入电话机器人名称【示例：云呼叫中心】"
          v-model="siteForm.robot_mobile"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话机器人样式：">
        <upload-img :img.sync="siteForm.robot_mobile_image"
          >建议上传图片尺寸为50px*50px</upload-img
        >
      </el-form-item>
      <!-- <el-form-item label="人工分答入口名称：">
        <el-input
          placeholder="输入人工分答名称【示例：人工问答】"
          v-model="siteForm.robot_art"
        ></el-input>
      </el-form-item>
      <el-form-item label="人工分答样式：">
        <upload-img :img.sync="siteForm.robot_art_image"
          >建议上传图片尺寸为50px*50px</upload-img
        >
      </el-form-item> -->
      <el-form-item label="入口名称颜色：">
        <el-input
          placeholder="输入入口名称颜色【示例：#ffffff】"
          v-model="siteForm.robot_color"
        ></el-input>
      </el-form-item>
      <el-form-item label="机器人位置：">
        <div class="robot-position">
          <div class="lf">
            <el-checkbox
              size="medium"
              v-for="(item, index) in lfCheckLabel"
              :key="index"
              :value="siteForm.robot_location == item"
              @change="handleCheckChange(item)"
            ></el-checkbox>
          </div>
          <div class="rt">
            <el-checkbox
              size="medium"
              v-for="(item, index) in rtCheckLabel"
              :key="index"
              :value="siteForm.robot_location == item"
              @change="handleCheckChange(item)"
            ></el-checkbox>
          </div>
          <span class="school-web">学校官网</span>
        </div>
      </el-form-item>
      <el-form-item label="接入代码：">
        <el-button type="three" @click="copy">复制</el-button>
      </el-form-item>
      <div class="tips">代码添加到网站源码中，放在&lt;head&gt;标签内</div>
      <el-button type="three" @click="submitForm" class="save">保存</el-button>
    </el-form>
  </div>
</template>

<script>
  import { getWebsite, saveWebsite } from '@/api/setBase'
  import { isEmpty, isSuccess } from '@/utils/index'
  export default {
    components: {
      'upload-img': () => import('@/components/uploadImg/index.vue'),
    },
    data() {
      return {
        siteForm: {
          robot_style: '',
          robot_show: [],
          robot_text: '',
          robot_mobile: '',
          robot_location: '',
          robot_text_image: '',
          robot_mobile_image: '',
          robot_color: '',
        },
        lfCheckLabel: ['leftTop', 'leftCenter', 'leftBottom'],
        rtCheckLabel: ['rightTop', 'rightCenter', 'rightBottom'],
        baseUrl: '',
        siteOrigin: {}, // 接口获取的源数据
      }
    },
    mounted() {
      this.getWebsite()
    },
    methods: {
      async getWebsite() {
        const res = await getWebsite()
        this.baseUrl = res.data.url
        if (res.data.detail != null) {
          let index = res.data.detail.robot_show.findIndex((val) => val == 2)
          if (index != -1) {
            res.data.detail.robot_show.splice(index, 1)
          }
          this.siteForm = {
            id: res.data.detail.id,
            robot_style: res.data.detail.robot_style,
            robot_show: res.data.detail.robot_show,
            robot_text: res.data.detail.robot_text,
            robot_mobile: res.data.detail.robot_mobile,
            robot_location: res.data.detail.robot_location,
            robot_text_image: res.data.detail.robot_text_image,
            robot_mobile_image: res.data.detail.robot_mobile_image,
            robot_color: res.data.detail.robot_color,
          }
          this.siteOrigin = JSON.parse(JSON.stringify(this.siteForm))
        } else {
          this.siteForm = {
            robot_style: 'icon/jqr.png',
            robot_show: ['1'],
            robot_text: '文字机器人',
            robot_mobile: '电话机器人',
            robot_location: 'rightCenter',
            robot_text_image: 'icon/wenzi.png',
            robot_mobile_image: 'icon/dianhua.png',
            robot_color: '#ffffff',
          }
        }
      },
      async submitForm() {
        if (isEmpty(this.siteForm)) {
          this.$message.error('信息不全， 请补全信息')
          return
        }
        const res = await saveWebsite({
          ...this.siteForm,
          code: this.getUrl(),
        })
        if (isSuccess(res.code)) {
          this.siteOrigin = JSON.parse(JSON.stringify(this.siteForm))
          this.$message.success('保存成功')
        }
      },
      handleCheckChange(e) {
        this.siteForm.robot_location = e
      },
      copy() {
        if (isEmpty(this.siteForm)) {
          this.$message.error('信息不全， 请补全信息再重试')
          return
        }
        if (this.checkHasChange()) {
          this.$message.error('信息改动，请先保存后再重试')
          return
        }
        let url = this.getUrl()
        try {
          const input = document.createElement('textarea')
          document.body.appendChild(input)
          input.value = url
          input.select()
          document.execCommand('Copy')
          input.remove()
          this.$message.success('复制成功')
        } catch (e) {
          this.$message.error('您的浏览器暂不支持复制')
        }
      },
      checkHasChange() {
        let hasChange = false
        Object.keys(this.siteOrigin).forEach((key) => {
          if (this.siteOrigin[key] instanceof Array) {
            if (this.siteOrigin[key].length != this.siteForm[key].length) {
              hasChange = true
              return
            }
            let index = 0
            this.siteOrigin[key].forEach((val) => {
              if (this.siteForm[key].find((val1) => val1 == val)) {
                index++
              }
            })
            if (index != this.siteOrigin[key].length) {
              hasChange = true
              return
            }
          } else {
            if (this.siteOrigin[key] != this.siteForm[key]) {
              hasChange = true
              return
            }
          }
        })
        return hasChange
      },
      getUrl() {
        let urlArr = this.baseUrl.split('?')
        let school = urlArr[1].split(',')
        let linkArr = []
        if (this.siteForm.robot_show.length == 1) {
          linkArr[0] = this.siteForm.robot_show[0]
          if (this.siteForm.robot_show[0] == '3') {
            linkArr[0] = '4'
          }
        } else if (this.siteForm.robot_show.length == 3) {
          linkArr[0] = '7'
        } else {
          if (
            this.siteForm.robot_show.filter(
              (item) => item == '1' || item == '2'
            ).length == 2
          ) {
            linkArr[0] = '3'
          } else if (
            this.siteForm.robot_show.filter(
              (item) => item == '1' || item == '3'
            ).length == 2
          ) {
            linkArr[0] = '5'
          } else if (
            this.siteForm.robot_show.filter(
              (item) => item == '2' || item == '3'
            ).length == 2
          ) {
            linkArr[0] = '6'
          }
        }

        linkArr[1] = school[1]
        linkArr[2] = '1'
        if (/right/.test(this.siteForm.robot_location)) {
          linkArr[2] = '2'
        }
        if (/top/i.test(this.siteForm.robot_location)) {
          linkArr[3] = '5'
        } else if (/center/i.test(this.siteForm.robot_location)) {
          linkArr[3] = '40'
        } else {
          linkArr[3] = '75'
        }
        linkArr[4] = this.getImageName(this.siteForm.robot_style)
        linkArr[5] = this.getImageName(this.siteForm.robot_text_image)
        linkArr[6] = ''
        linkArr[7] = this.getImageName(this.siteForm.robot_mobile_image)
        linkArr[8] = this.siteForm.robot_text
        linkArr[9] = ''
        linkArr[10] = this.siteForm.robot_mobile
        linkArr[11] = this.siteForm.robot_color
        return `\<script defer id="school-pai" src="${
          this.baseUrl + ',' + linkArr.join(',')
        }"\>\<\/script\>`
      },

      getImageName(url) {
        let arr = url.split('.')
        // let name = arr[arr.length - 1].split('.')
        return arr[0]
      },
    },
  }
</script>
<style lang="scss">
  .site-access {
    .editor {
      width: 780px;
    }
    .tips {
      margin: -30px 0 20px 0;
      font-size: 14px;
    }
    .robot-position {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 220px;
      height: 120px;
      border-radius: 10px;
      border: 1px solid #d7d7d7;
      .school-web {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .lf,
      .rt {
        display: flex;
        flex-direction: column;
      }
      .el-checkbox {
        margin: 0 10px;
      }
      .el-checkbox__inner {
        width: 18px;
        height: 18px;
      }
      .el-checkbox__inner::after {
        width: 4px;
        height: 9px;
        left: 6px;
      }
    }

    .el-input {
      width: 500px;
    }
    .save {
      margin-top: 50px;
    }
  }
</style>
